/**
 *  TopbarMobileMenu prints the menu content for authenticated user or
 * shows login actions for those who are not authenticated.
 */
import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routeConfiguration';
import { ensureCurrentUser } from '../../util/data';
import {
  InlineTextButton,
  NamedLink,
  NotificationBadge,
} from '../../components';

import css from './TopbarMobileMenu.css';
import MobileMenuCategories from './MobileMenuCategories';

const TopbarMobileMenu = props => {
  const {
    isAuthenticated,
    currentPage,
    currentUserHasListings,
    currentUserProviderId,
    currentUser,
    notificationCount = 0,
    onLogout,
    onDktLogin,
  } = props;

  const user = ensureCurrentUser(currentUser);
  const isOfferEnabled = user.attributes.hasProvider || user.attributes.isAdmin;

  if (!isAuthenticated) {
    return (
      <div className={css.root}>
        <div className={css.content}>
          <span className={css.greeting}></span>
          <MobileMenuCategories />
          <div>
            <a className={css.loginLink} onClick={() => onDktLogin()}>
              <span className={css.login}>
                <FormattedMessage id="TopbarMobileMenu.login" />
              </span>
            </a>
          </div>
          {/* <div className={css.authenticationGreeting}>
            <FormattedMessage
              id="TopbarMobileMenu.unauthorizedGreeting"
              values={{ lineBreak: <br />, signupOrLogin }}
            />
          </div> */}
        </div>
        {
          isOfferEnabled &&
          <div className={css.footer}>
            <NamedLink className={css.createNewListingLink} name="NewListingPage">
              <FormattedMessage id="TopbarMobileMenu.newListingLink" />
            </NamedLink>
          </div>
        }
      </div>
    );
  }

  const notificationCountBadge =
    notificationCount > 0 ? (
      <NotificationBadge className={css.notificationBadge} count={notificationCount} />
    ) : null;

  const displayName = user.attributes.firstName;
  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };

  return (
    <div className={css.root}>
      {/*<AvatarMedium className={css.avatar} user={currentUser} disableProfileLink/>*/}
      <div className={css.content}>
        <span className={css.greeting}>
          {/*<IconBasket />*/}
          <FormattedMessage id="TopbarMobileMenu.greeting" values={{ displayName }} />
        </span>
        <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
          <FormattedMessage id="TopbarMobileMenu.logoutLink" />
        </InlineTextButton>
        <MobileMenuCategories />
        <NamedLink
          className={classNames(css.inbox, currentPageClass('InboxPage'))}
          name="InboxPage"
          params={{ tab: currentUserHasListings ? 'sales' : 'orders', providerId: currentUserProviderId || 'orders' }}
        >
          <FormattedMessage id="TopbarMobileMenu.inboxLink" />
          {notificationCountBadge}
        </NamedLink>
        {
          isOfferEnabled &&
          <NamedLink
            className={classNames(css.navigationLink, currentPageClass('ManageListingsPage'))}
            name="ManageListingsPage"
            params={{ providerId: currentUserProviderId || 'orders' }}
          >
            <FormattedMessage id="TopbarMobileMenu.yourListingsLink" />
          </NamedLink>
        }
        <NamedLink
          className={classNames(css.navigationLink, currentPageClass('ProfileSettingsPage'))}
          name="ProfileSettingsPage"
        >
          <FormattedMessage id="TopbarMobileMenu.profileSettingsLink" />
        </NamedLink>
        <NamedLink
          className={classNames(css.navigationLink, currentPageClass('InvoiceSettingsPage'))}
          name="InvoiceSettingsPage"
        >
          <FormattedMessage id="TopbarMobileMenu.invoiceSettingsLink" />
        </NamedLink>
        {
          (user?.attributes.isAdmin || user.attributes.adminForCountries?.length > 0) ?
          <NamedLink
            className={classNames(css.navigationLink, currentPageClass('ConsoleTransactionPage'))}
            name="ConsoleTransactionPage"
          >
            <FormattedMessage id="TopbarMobileMenu.consoleLink" />
          </NamedLink> : null
        }
      </div>
      {
        isOfferEnabled &&
        <div className={css.footer}>
          <NamedLink className={css.createNewListingLink} name="NewListingPage">
            <FormattedMessage id="TopbarMobileMenu.newListingLink" />
          </NamedLink>
        </div>
      }
    </div>
  );
};

export default TopbarMobileMenu;
